import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
          <path d="M11.5 5.5L11.5 13.5 8.5 13.5 11.5 22.5 7.5 22.5 4.5 13.5 0.5 13.5 0.5 5.5z"/>
          <path d="M11.5,5.5 C15.4,5.5 21.5,2.5 21.5,2.5 C22.7,2.5 23.5,5 23.5,9.5 C23.5,14 22.7,16.5 21.5,16.5 C21.5,16.5 15.4,13.5 11.5,13.5" strokeLinejoin="round"/>
        </g>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M23.5 12.5L23.5 26.5 17.5 26.5 23 42.5 15.5 42.5 10.5 26.5 3.5 26.5 3.5 12.5z"/>
        <path d="M23.5,12.5 C30.8,12.5 41,6.5 41,6.5 C43,6.5 44.5,11.7 44.5,19.5 C44.5,27.3 43,32.5 41,32.5 C41,32.5 30.8,26.5 23.5,26.5" strokeLinejoin="round"/>
      </g>
    </svg>
  );
};
